import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { QuantiteDossierPortefeuilleDTO } from '../model/quantite-dossier-portefeuille-dto';
import { QuantiteTotalByWorkflowDTO } from '../model/quantite_by_workflow/quantite-total-by-workflow-dto';
import { ValeurDossierPortefeuilleDTO } from '../model/valeur-dossier-portefeuille-dto';
import { DashboardDossierCredit } from '../model/DashboardDossierCredit';
import { PageDashboardDossierCredit } from '../model/PageDashboardDossierCredit';
import { QuantiteMontantWorkflowDTO } from '../model/quantite_by_workflow/quantite-montant-workflow-dto';

@Injectable({
    providedIn: 'root'
  })
  export class DashboardPersonnelService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    quantiteDossierPortefeuilleByUsername(workflow,username) 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleDTO>('dashboard-personnel/quantite-dossier-portefeuille-by-username'
        +'?username='+username+'&workflow='+workflow);
    }
    
    quantiteDossierEncoursForAllWorkflowByUsername(username) 
    {
        return this._restClientService.load<QuantiteTotalByWorkflowDTO>('dashboard-personnel/quantite-dossier-en-cours-for-all-workflow-by-username'
        +'?username='+username);
    }
    
    quantiteDossierACorrigerForAllWorkflowByUsername(username) 
    {
        return this._restClientService.load<QuantiteTotalByWorkflowDTO>('dashboard-personnel/quantite-dossier-a-corriger-for-all-workflow-by-username'
        +'?username='+username);
    }
    
    quantiteDossierValideForAllWorkflowByUsername(username) 
    {
        return this._restClientService.load<QuantiteTotalByWorkflowDTO>('dashboard-personnel/quantite-dossier-valide-for-all-workflow-by-username'
        +'?username='+username);
    }
    
    quantiteDossierEnRetardForAllWorkflowByUsername(username) 
    {
        return this._restClientService.load<QuantiteTotalByWorkflowDTO>('dashboard-personnel/quantite-dossier-en-retard-for-all-workflow-by-username'
        +'?username='+username);
    }
    
    pourcentageDossierByStatus(username,debut,fin) 
    {
        return this._restClientService.load<any[]>('dashboard-personnel/pourcentage-dossier-by-status?username='+username+'&debut='+debut+'&fin='+fin);
    }
    
    dossiersCreesSur12DerniersMois(username, datefin) 
    {
        return this._restClientService.load<any[]>('dashboard-personnel/dossiers-crees-sur-12-derniers-mois?username='+username+'&datefin='+datefin);
    }
    
    valeurDossierPortefeuille(username,debut,fin) 
    {
        return this._restClientService.load<QuantiteMontantWorkflowDTO[]>('dashboard-personnel/valeur-dossier-portefeuille'+'?username='+username+'&debut='+debut+'&fin='+fin);
    }
    
    
    /********* CREDIT CARD VIEW **************/
    getDossiersPersonnelStatus(filter: string, pageIndex: number, pageSize: number, username: string): any {
      return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-personnel/dossiers-presonnel-status?filter=${filter}&page=${pageIndex}&size=${pageSize}&username=${username}`);
    }
     getDossiersPersonnel(filter: string, pageIndex: number, pageSize: number, username: string, state: String): any {
      return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-personnel/find-all-presonnel?filter=${filter}&page=${pageIndex}&size=${pageSize}&username=${username}&state=${state}`);
    }
    
    getDossiersCreditEnCours(filter: string, pageIndex: number, pageSize: number, username: string): any {
        return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-personnel/dossiers-credit-en-cours?filter=${filter}&page=${pageIndex}&size=${pageSize}&username=${username}`);
      }
  
      getDossiersCreditEnRetard(filter: string, pageIndex: number, pageSize: number, username: string): any {
        return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-personnel/dossiers-credit-en-retard?filter=${filter}&page=${pageIndex}&size=${pageSize}&username=${username}`);
      }
  
      getDossiersCreditMiseEnPlace(filter: string, pageIndex: number, pageSize: number, username: string): any {
        return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-personnel/dossiers-credit-mise-en-place?filter=${filter}&page=${pageIndex}&size=${pageSize}&username=${username}`);
      }
      
      getDossiersCreditEnCorrection(filter: string, pageIndex: number, pageSize: number, username: string): any {
        return this._restClientService.load<PageDashboardDossierCredit>(`dashboard-personnel/dossiers-credit-en-correction?filter=${filter}&page=${pageIndex}&size=${pageSize}&username=${username}`);
      }

    

}